import axios from "axios";

const uris = {
  dev: "https://dev.api.doorvi.co",
  production: "https://api.doorvi.co",
  callProductionUri: "https://call.doorvi.co/",
  referUrl: "https://referral.api.doorvi.co",
  callDevUri: "https://dev.call.doorvi.co/",
};

export default axios.create({
  baseURL: `${uris.production}/api`,
  timeout: 240000,
});

export { uris };
